import React from 'react'
import { ThemeWrapper, PAYPAL_THEME, Toast } from '@paypalcorp/pp-react'
import { connect } from '../../utils/p2p-connect'
import { closeGlobalToast } from '../../actions/global-toast'
import Portal from 'react-components/overpanel/portal'

type GlobalToastProps = {
  showGlobalToast: boolean,
  type: string,
  message: string,
  dispatch: Function,
  duration?: string,
}

function GlobalToast(props: GlobalToastProps) {
  const { showGlobalToast, type, message, duration, dispatch } = props

  const handleClose = () => {
    dispatch(closeGlobalToast())
  }

  if (!showGlobalToast) {
    return null
  }

  return (
    <Portal>
      <ThemeWrapper theme={PAYPAL_THEME}>
        <Toast
          id="p2p-global-toast"
          data-testid="global-toast"
          type={type}
          isSuccess={type === 'success'} // (Deprecated) It is necessary now, but remove when pp-react is updated
          message={message}
          {...(duration && { duration })}
          onClose={handleClose}
        />
      </ThemeWrapper>
    </Portal>
  )
}

export default connect(({ globalToast }) => ({
  showGlobalToast: globalToast.show,
  type: globalToast.type,
  message: globalToast.message,
  duration: globalToast.duration,
}))(GlobalToast)
